import React, { useState } from "react";
import { observer } from "mobx-react";
import { appStore } from "../../../../store/AppStore";
import { Form, Input, Modal, Select, Button, Typography } from "antd";
import NumberFormat from "react-number-format";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};
const tailLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};
export const RemindDonateDlg = observer(() => {
  const [form] = Form.useForm();
  const [type, setType] = useState("Email");
  const { inviteDonateStore } = appStore.parent;
  inviteDonateStore.form2 = form;

  const onInvite = () => {
    form.validateFields().then((values) => {
      inviteDonateStore.sendRemide(values);
    });
  };

  return (
    <Modal
      footer={null}
      title="Edit Family & Friends Info"
      visible={inviteDonateStore.showRemide}
      onCancel={() => inviteDonateStore.close()}
    >
      <Form form={form} initialValues={{ inviteType: "Email" }} {...layout}>
        <Typography.Paragraph style={{ padding: "0 6px", marginBottom: 48 }}>
          If this person has not made a donation, a new invitation will be sent. If a donation has been made, no more
          communication will be made.
        </Typography.Paragraph>

        <Form.Item label="First/Nick Name" name="inviteName" rules={[{ required: true }]}>
          <Input></Input>
        </Form.Item>
        <Form.Item label="Contact Method" name="inviteType" rules={[{ required: true }]}>
          <Select
            onChange={(e: string) => {
              setType(e);
              form.setFieldsValue({ contact: "" });
            }}
          >
            <Select.Option value="Email">Email</Select.Option>
            <Select.Option value="Mobile">Mobile</Select.Option>
          </Select>
        </Form.Item>
        {type === "Email" && (
          <Form.Item label="Email" name="inviteData" rules={[{ required: true, type: "email" }]}>
            <Input></Input>
          </Form.Item>
        )}
        {type === "Mobile" && (
          <Form.Item label="Mobile" name="inviteData" rules={[{ required: true }]}>
            <NumberFormat format="+1 (###) ###-####" mask="_" className="ant-input" />
          </Form.Item>
        )}
        <Form.Item style={{ textAlign: "center" }} {...tailLayout}>
          <Button type="primary" shape="round" size="large" onClick={onInvite} loading={inviteDonateStore.saving}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
});
